import React, { useCallback, useEffect, useState } from 'react';
import userType from '../../../types/userType';
import UserOverviewTemplate from '../../04_templates/UserOverviewTemplate/UserOverviewTemplate';
import useAPI from '../../../hooks/useAPI';

function UserOverviewPage() {
    const [users, setUsers] = useState<userType[]>([]);
    const { Get } = useAPI();

    const fetchUsers = useCallback(async () => {
        try {
            const data = await Get<userType[]>('/admin/users');
            setUsers(data);
        } catch (error) {
            globalThis.dispatchEvent(
                new CustomEvent('ShowAlert', {
                    detail: {
                        label:
                            error instanceof Error
                                ? error.message
                                : 'Er is een fout opgetreden bij het ophalen van de gebruikers',
                        type: 'Warning',
                    },
                }),
            );
        }
    }, [Get]);

    useEffect(() => {
        document.title = 'Sweet Bibi - Gebruikers';
        fetchUsers();
    }, [fetchUsers]);

    return (
        <main>
            <UserOverviewTemplate users={users} onRefresh={fetchUsers} />
        </main>
    );
}

export default UserOverviewPage;
